import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { SelectedCompanyRoleEvent } from 'src/app/components/assign-role/assign-role.component';
import { SelectedUserEvent } from 'src/app/components/user-search-bar/user-search-bar.component';
import { ApiLoadingKeys, ApiService } from 'src/app/services/api.services';
import { UserProfileService } from 'src/app/services/user-profile.service';
import { NotAuthorizedNoticeComponent } from '../../../components/not-authorized-notice/not-authorized-notice.component';
import { HasSystemCapabilityDirective } from '../../../directives/system-capabilities/has-system-capability.directive';
import { AssignRoleComponent } from '../../../components/assign-role/assign-role.component';

@Component({
	selector: 'app-add-user-assign-role',
	templateUrl: './add-user-assign-role.component.html',
	styleUrls: [
		'./add-user-assign-role.component.css',
		'../../common/main.scss',
		'../../common/stepper.scss',
	],
	imports: [
		NotAuthorizedNoticeComponent,
		HasSystemCapabilityDirective,
		AssignRoleComponent,
	],
})
export class AddUserAssignRoleComponent {
	@Input() companyId?: string;
	@Input() userEvent?: SelectedUserEvent;
	@Output() selectedCompanyRoleEvents =
		new EventEmitter<SelectedCompanyRoleEvent>();
	confirmButtonDisabled = true;

	apiLoadingKeys = ApiLoadingKeys;

	constructor(
		private readonly dialog: MatDialog,
		private readonly stepper: MatStepper,
		private readonly apiService: ApiService,
		private readonly userProfileService: UserProfileService
	) {}

	onSelectionChangedEvent(event: SelectedCompanyRoleEvent | undefined): void {
		const invalidRole =
			event?.company === undefined || event?.role === undefined;
		const invalidNewRoleInformation =
			(event?.newRoleInformation?.name ?? '').length === 0 ||
			(
				event?.newRoleInformation?.systemCapabilityItems?.filter(
					(item) => !!item.granted
				) ?? []
			).length === 0;

		this.confirmButtonDisabled = invalidRole && invalidNewRoleInformation;
		this.selectedCompanyRoleEvents.emit(event);
	}
}
